import React from 'react'

import { NO_MATCH_LABEL, SOLD_OUT_LABEL } from './constants'

interface LevelCardProps {
  label: string
  availableCount: number
  availableStatusLabel: string
  availableStatusColour: string
  isSelected: boolean
  isDisabled: boolean
  onSelect: () => void
}

function LevelCard({
  label,
  availableCount,
  availableStatusLabel,
  availableStatusColour,
  isSelected,
  isDisabled,
  onSelect,
}: LevelCardProps) {
  const hasAvailableUnits = !isDisabled && availableCount > 0

  const getStatusText = () => {
    if (isDisabled) {
      return NO_MATCH_LABEL
    }
    if (hasAvailableUnits) {
      return `${availableCount} ${availableStatusLabel}`
    }
    return SOLD_OUT_LABEL
  }

  return (
    <button
      type="button"
      aria-pressed={isSelected}
      disabled={isDisabled}
      onClick={onSelect}
      className={`group flex w-full flex-col gap-2 rounded-[5px] border border-transparent bg-white py-3 pr-4 text-left transition-colors duration-200 disabled:pointer-events-none disabled:bg-[#F0F0F0] xl:pb-[15px] xl:pt-3.5 desktop-all:py-[15px] desktop-large:gap-2.5 desktop-large:pb-4 desktop-large:pr-[18px] ${
        isSelected
          ? 'border-l-[5px] border-l-mainColour pl-[21px] desktop-large:border-l-[6px] desktop-large:pl-[23px]'
          : 'pl-4 desktop-large:pl-[18px]'
      }`}
    >
      <span className="truncate text-lg font-bold leading-none text-black group-disabled:text-[#AFAFAF] desktop-all:text-xl/none desktop-large:text-[22px]">
        {label}
      </span>
      <span className="flex items-center gap-1 text-[11px] font-semibold uppercase leading-none tracking-[0.04em] text-[#666666] group-disabled:text-[#AFAFAF] desktop-all:text-xs/none desktop-large:text-[13px]">
        {hasAvailableUnits && (
          <span
            className="h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: availableStatusColour }}
          />
        )}
        <span className="truncate">{getStatusText()}</span>
      </span>
    </button>
  )
}

export default LevelCard
